
import {
  computed,
  defineComponent,
  ref,
} from 'vue';

import LazyBackgroundMedia from '@/components/LazyBackgroundMedia.vue';
import Observer from '@/components/Observer.vue';

export default defineComponent({
  components: {
    Observer,
    LazyBackgroundMedia,
  },

  props: {
    mediaId: {
      type: String,
      required: false,
      default: () => '0',
    },
    mediaSizes: {
      type: String,
      required: false,
      default: () => btoa('null'),
    },
    backgroundPositionY: {
      type: String,
      required: false,
      default: () => 'top',
    },
    backgroundPositionX: {
      type: String,
      required: false,
      default: () => 'center',
    },
    mediaMobileId: {
      type: String,
      required: false,
      default: () => '0',
    },
    mediaMobileSizes: {
      type: String,
      required: false,
      default: () => btoa('null'),
    },
    backgroundPositionMobileY: {
      type: String,
      required: false,
      default: () => 'same',
    },
    backgroundPositionMobileX: {
      type: String,
      required: false,
      default: () => 'same',
    },
    imageAlign: {
      type: String,
      required: false,
      default: () => 'center',
    },
  },

  setup(props) {
    const hasMedia = props.mediaId !== '0';

    const hovering = ref(false);
    const observed = ref(false);

    const classes = computed(() => {
      const classArr = [];

      classArr.push(`media-${props.imageAlign}`);

      if (hovering.value) {
        classArr.push('hover');
      }

      if (observed.value) {
        classArr.push('observed');
      }

      return classArr;
    });

    return {
      hovering,
      observed,
      classes,
      hasMedia,
    };
  },
});
